// extracted by mini-css-extract-plugin
export default {"icon":"CardOverdraftUpdate_icon__hFKuI"};